import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Merge } from "lucide-react";

export function DuplicatesDialog({ open, onOpenChange, dupes, merging, onMergeGroup, onMergeAll }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Dédoublonnage clients ({dupes.length} groupes)</DialogTitle>
        </DialogHeader>
        {dupes.length > 0 && (
          <Button onClick={onMergeAll} disabled={merging} className="bg-indigo-600 hover:bg-indigo-700 text-white text-xs mb-4" data-testid="merge-all-btn">
            <Merge size={14} className="mr-1.5" /> Tout fusionner automatiquement ({dupes.length} groupes)
          </Button>
        )}
        {dupes.length === 0 && <p className="text-center text-slate-400 py-8">Aucun doublon détecté</p>}
        <div className="space-y-4">
          {dupes.map((group) => (
            <Card key={group.company} className="p-4 border border-slate-200" data-testid={`dupe-group-${group.company}`}>
              <div className="flex items-center justify-between mb-3">
                <div>
                  <span className="font-bold text-slate-900">{group.company}</span>
                  <Badge variant="outline" className="ml-2 text-xs">{group.count} fiches</Badge>
                </div>
                <Button size="sm" onClick={() => onMergeGroup(group)} disabled={merging} className="bg-indigo-600 hover:bg-indigo-700 text-white text-xs" data-testid={`merge-group-${group.company}`}>
                  <Merge size={12} className="mr-1" /> Fusionner
                </Button>
              </div>
              <Table>
                <TableHeader>
                  <TableRow className="bg-slate-50">
                    <TableHead className="text-xs">Société</TableHead>
                    <TableHead className="text-xs">Email</TableHead>
                    <TableHead className="text-xs">Téléphone</TableHead>
                    <TableHead className="text-xs">Ville</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {group.clients.map((c, ci) => (
                    <TableRow key={c.id || `client-${ci}`} className={ci === 0 ? "bg-emerald-50" : ""}>
                      <TableCell className="text-sm font-medium">{c.company}{ci === 0 && <Badge className="ml-2 bg-emerald-100 text-emerald-700 text-[10px]">Principal</Badge>}</TableCell>
                      <TableCell className="text-sm">{c.email || "-"}</TableCell>
                      <TableCell className="text-sm">{c.phone || "-"}</TableCell>
                      <TableCell className="text-sm">{c.city || "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Card>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
